(function () {
  // Clean-URL client-side pagination for author-filtered blog-posts sections.
  // The server renders ALL of the author's posts (up to Shopify's 250 cap); this
  // script shows `data-per-page` cards at a time based on the ?p=N query param,
  // keeping the /pages/<author> URL and real, shareable <a href="?p=N"> links.
  function apply(root) {
    var grid = root.querySelector("[data-author-grid]");
    if (!grid) return;

    var perPage = parseInt(grid.getAttribute("data-per-page"), 10) || 48;
    var cards = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList && el.classList.contains("blog-posts-card");
    });

    var total = cards.length;
    if (!total) return;

    var totalPages = Math.ceil(total / perPage);

    var params = new URLSearchParams(window.location.search);
    var current = parseInt(params.get("p"), 10);
    if (!current || current < 1) current = 1;
    if (current > totalPages) current = totalPages;

    var start = (current - 1) * perPage;
    var end = start + perPage;
    var coeff = perPage > 24 ? 0.025 : perPage > 12 ? 0.05 : 0.1;

    // Take over from the CSS-only "hide beyond first page" fallback so that JS
    // controls which slice is visible (otherwise the static rule keeps 49+ hidden).
    root.classList.add("author-pagination-ready");

    cards.forEach(function (card, i) {
      if (i >= start && i < end) {
        card.style.display = "";
        card.style.setProperty(
          "--blog-posts-card-delay",
          (i - start) * coeff + "s"
        );
      } else {
        card.style.display = "none";
      }
    });

    var nav = root.querySelector("[data-author-pagination]");
    if (!nav) return;

    nav.querySelectorAll("[data-page]").forEach(function (a) {
      var n = parseInt(a.getAttribute("data-page"), 10);
      var isCurrent = n === current;
      a.classList.toggle("pagination__item--current", isCurrent);
      if (isCurrent) {
        a.setAttribute("aria-current", "page");
      } else {
        a.removeAttribute("aria-current");
      }
    });

    var prev = nav.querySelector("[data-prev]");
    var next = nav.querySelector("[data-next]");

    if (prev) {
      if (current > 1) {
        prev.style.display = "";
        prev.setAttribute("href", "?p=" + (current - 1));
      } else {
        prev.style.display = "none";
      }
    }

    if (next) {
      if (current < totalPages) {
        next.style.display = "";
        next.setAttribute("href", "?p=" + (current + 1));
      } else {
        next.style.display = "none";
      }
    }
  }

  function init(scope) {
    (scope || document)
      .querySelectorAll("[data-author-paginated]")
      .forEach(apply);
  }

  if (document.readyState !== "loading") {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      init();
    });
  }

  document.addEventListener("shopify:section:load", function (e) {
    init(e.target);
  });
})();
